import SalesPrivateApiModel from '../../abstracts/SalesPrivateApiModel';

export default class ExportReadModel extends SalesPrivateApiModel {
	static get path(): string {
		return '/exports/{?id}/read';
	}
}
